import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { useQuickAddReplaceItemStore } from "./quick-add-replace-item-store";
import { addReplaceListItem } from "./replace-list-store";

function close() {
  useQuickAddReplaceItemStore.setState({ list: null });
}

function add() {
  const { list, from, to } = useQuickAddReplaceItemStore.getState();
  addReplaceListItem(list?._id || "", from, to);
  useQuickAddReplaceItemStore.setState({ list: null, from: "", to: "" });
}

export function QuickAddReplaceItem() {
  const { t } = useTranslation();
  const from = useQuickAddReplaceItemStore((state) => state.from);
  const to = useQuickAddReplaceItemStore((state) => state.to);
  const list = useQuickAddReplaceItemStore((state) => state.list);

  return (
    <Dialog
      open={!!list}
      onClose={close}
      sx={{
        display: "flex",
        justifyContent: "right",
      }}
      PaperProps={{ sx: { alignSelf: "flex-start" } }}
      transitionDuration={0}
      disableRestoreFocus
    >
      <DialogTitle>
        {`${t("Replace list")}`}: {list?.name}
      </DialogTitle>
      <DialogContent>
        <TextField
          onKeyDown={(e) => {
            e.key === "Enter" && add();
          }}
          autoFocus
          autoComplete="off"
          margin="dense"
          id="replaceKey"
          label={t("from")}
          type="text"
          variant="standard"
          value={from}
          onChange={(e) =>
            useQuickAddReplaceItemStore.setState({ from: e.target.value })
          }
        />
        <TextField
          onKeyDown={(e) => e.key === "Enter" && add()}
          autoComplete="off"
          margin="dense"
          id="replaceValue"
          label={t("to")}
          type="text"
          variant="standard"
          value={to}
          onChange={(e) =>
            useQuickAddReplaceItemStore.setState({ to: e.target.value })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{t("Cancel")}</Button>
        <Button onClick={add}>{t("Create")}</Button>
      </DialogActions>
    </Dialog>
  );
}
